import { POPOVER_MESSAGES, PopoverMessages } from "../popover.messages";
import { TABLE_COLUMNS_MESSAGES, TableColumnsMessages } from "../tables/columns.messages";

export type NotificationsTableMessages = TableColumnsMessages &
  PopoverMessages & {
    // Mensagens de erro
    notificationNotFoundError: string;
    notificationNotFoundDescription: string;
    notificationNotFoundAlt: string;
    notificationErrorToLoad: string;

    // Título da tabela
    notificationTableTitle: string;

    // Colunas da tabela
    readStatusColumn: string;
    dateTimeColumn: string;
    detailsColumn: string;
  };

export const NOTIFICATIONS_TABLE_MESSAGES: NotificationsTableMessages = {
  ...TABLE_COLUMNS_MESSAGES,

  // Mensagens de erro
  notificationNotFoundError: "Notificação não encontrada",
  notificationNotFoundDescription: "Descrição da notificação não encontrada",
  notificationNotFoundAlt: "Notificação não encontrada alternativa",
  notificationErrorToLoad: "Erro ao carregar notificações",

  // Título da tabela
  notificationTableTitle: "Listagem de Notificações",

  // Colunas da tabela
  readStatusColumn: "Lida",
  dateTimeColumn: "Data e Hora",
  detailsColumn: "Detalhes",

  ...POPOVER_MESSAGES,
};

export default NOTIFICATIONS_TABLE_MESSAGES;
